import { api } from "./client";
import { apiError } from "./errors";
import type { components } from "./schema";

export type LoginResponse = components["schemas"]["LoginResponse"];
export type TenantOption = components["schemas"]["TenantOption"];

const INVALID_CREDENTIALS_MESSAGE = "El identificador o la contraseña son incorrectos.";

export async function login(identifier: string, password: string): Promise<LoginResponse> {
  const { data, error, response } = await api.POST("/auth/login", {
    body: { identifier, password },
  });
  if (error || !data) {
    throw loginError(error, response);
  }
  return data;
}

export async function loginSelect(
  disambiguationToken: string,
  tenantId: string,
): Promise<LoginResponse> {
  const { data, error, response } = await api.POST("/auth/login/select", {
    body: { disambiguation_token: disambiguationToken, tenant_id: tenantId },
  });
  if (error || !data) {
    throw loginError(error, response);
  }
  return data;
}

function loginError(error: unknown, response: Response | undefined) {
  const err = apiError(error, response, "No se pudo iniciar sesión");
  if (err.status === 401) {
    return apiError({ detail: INVALID_CREDENTIALS_MESSAGE }, response, INVALID_CREDENTIALS_MESSAGE);
  }
  return err;
}
